import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import {
	TEudrItemsRequest,
	TEudrItemsResponsePayload,
	TGenerateEudrInvoiceRequest,
	TDownloadEudrLastInvoiceRequest,
	TEudrActivateRequest,
} from 'redux/reducers/eudr/types';
import {
	TEudrApi,
	TEudrPlans,
	TEudrServiceStatuses,
	TEudrRegParseRequest,
	TEudrRegParsed,
	TEudrRegisterRequest,
} from './types';

export const eudr: TEudrApi = {
	getEudrPlans: () =>
		http.get(endpoint.eudr.GET_PLANS).then(response => response.data as TEudrPlans),
	getEudrServiceStatuses: () =>
		http
			.get(endpoint.eudr.GET_SERVICE_STATUSES)
			.then(response => response.data as TEudrServiceStatuses),
	regParseEudr: (payload: TEudrRegParseRequest) =>
		http.post(endpoint.eudr.REG_PARSE, payload).then(response => response.data as TEudrRegParsed),
	registerEudr: (payload: TEudrRegisterRequest) =>
		http.post(endpoint.eudr.REGISTER, payload).then(() => {}),
	getEudrItems: (payload: TEudrItemsRequest) =>
		http
			.post(endpoint.eudr.EUDR_ITEMS, payload)
			.then(response => response.data as TEudrItemsResponsePayload),
	generateInvoiceEudr: (payload: TGenerateEudrInvoiceRequest) =>
		http.post(endpoint.eudr.GENERATE_INVOICE(payload.id)),
	downloadEudrLastInvoice: (payload: TDownloadEudrLastInvoiceRequest) =>
		http
			.get(endpoint.eudr.DOWNLOAD_LAST_INVOICE(payload.id), { responseType: 'blob' })
			.then(response => response.data),
	activateEudr: (payload: TEudrActivateRequest) =>
		http.post(endpoint.eudr.ACTIVATE_EUDR(payload.id)).then(() => {}),
};
